module.exports = __webpack_public_path__ + "img/download.9a337e05.jpg";